import { Context, Fragment } from 'react';
import { get, has } from 'lodash';
import { SurveyQuestionRadioItem } from 'survey-react-ui';

import classNames from 'classnames';
import { IonItem, IonRadio } from '@ionic/react';

import { SurveyContext, SurveyContextProps } from '../Survey.context';

import groupStyles from '../../Form/_styles/group.module.scss';
import styles from './SurveyRadioGroupItem.module.scss';

export class SurveyRadioGroupItem extends SurveyQuestionRadioItem {
  static contextType: Context<SurveyContextProps> = SurveyContext;
  context!: React.ContextType<typeof SurveyContext>;

  protected renderElement(): JSX.Element {
    const id = this.question.getItemId(this.item);

    // @ts-ignore
    const itemLabel = !this.hideCaption
      ? this.renderLocString(this.item.locText, this.textStyle)
      : null;

    const itemImage = has(this.context.optionsImages, [
      this.question.name,
      this.item.value,
    ]) ? (
      <Fragment>
        <img
          src={get(this.context.optionsImages, [
            this.question.name,
            this.item.value,
          ])}
          className={styles.image}
          alt=""
        />
        &nbsp;&nbsp;&nbsp;
      </Fragment>
    ) : null;

    return (
      <IonItem
        lines="full"
        onClick={() => this.handleOnChange(this.item.value)}
        className={classNames(groupStyles.item, {
          [groupStyles.md]: !itemImage,
          [groupStyles.sm]: !!itemImage,
        })}
      >
        <IonRadio
          id={id}
          value={this.item.value}
          name={this.question.questionName}
          justify="start"
          labelPlacement="end"
          className={groupStyles.control}
          disabled={!this.question.getItemEnabled(this.item)}
        >
          <div className={classNames(groupStyles.content)}>
            {itemImage}
            {itemLabel}
          </div>
        </IonRadio>
      </IonItem>
    );
  }
}
